'use strict';

let OCLE;

module.exports = function getOcleFromOptions(options) {
    if (OCLE) return OCLE;
    if (options.OCLE) {
        return OCLE = options.OCLE;
    } else {
        return OCLE = require('openchemlib-extended-minimal');
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/nmr-predictor/src/getOcleFromOptions.js
// module id = 13
// module chunks = 0